import { useEffect } from 'react';
import { Outlet, useLocation, useParams, useNavigate } from 'react-router-dom';
import Menu from './partials/Menu.tsx';
import Header from './partials/Header.tsx';
import { useResponsesStore } from './stores/Responses.ts';
import { findResponse } from './utils/FormFunctions.ts';
import pages from '../config/pages.json';
import AreYouSure from './partials/AreYouSure.tsx';
import NavigationListener from './utils/NavigationListener';
import Image from './partials/Image.tsx';
import ScrollToTop from './utils/ScrollToTop.tsx';

import '@shoelace-style/shoelace/dist/themes/light.css';
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path';

setBasePath('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.19.0/cdn/');

export function Root() {
    const { pageId } = useParams();
    const page = pages.find((page) => page.id === pageId);
    const { pathname } = useLocation();
    const { responses } = useResponsesStore(state => state);
    const navigate = useNavigate();

    useEffect(() => {
        // if country is not selected, redirect to the first page -- avoids navigation after completion
        if (!['intro','get-started','country','complete'].includes(pageId)) {
            const country = findResponse(responses, 'country');
            if (!country) navigate(pages[0].path);
        }
    }, [pathname]); // runs every time location changes

    const pl = page && page.showInSidebar !== false ? 'pl-0 md:pl-[215px]' : 'pl-0';
    
    return (
        <div className="min-h-svh flex flex-col bg-calm">
            <ScrollToTop />
            <NavigationListener />
            <Header page={page} />

            <div className={`flex flex-grow ${pl}`} id="full">
                { page && page.showInSidebar !== false && <Menu /> }

                <div className="flex-grow bg-calm flex justify-center">
                    <Outlet />
                </div>
            </div>

            <div className="hidden md:block fixed left-5 bottom-[27px]">
                <Image
                    src="Nohma_logo-59_z9mv67.png"
                    params={{width: 141, height: 27}}
                    alt="logo"
                />
            </div>

            <AreYouSure/>

            { !page?.hideGradient &&
                <MobileGradient />
            }
        </div>
    );
}

const MobileGradient = () => {
    return (
        <div className="fixed md:hidden bottom-0 w-full h-[100px] bg-gradient-to-t from-calm/100 from-10% via-calm/60 via-50% to-calm/0 to-90%"></div>
    );
}
